


import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  isSessionExpired,
  logout,
} from "../Utils/SessionManager";

function ProtectedRoute({ children }) {
  const location = useLocation();
  const isLoggedIn =
    sessionStorage.getItem("isLoggedIn") === "true";

  // Not logged in
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // Session expired
  if (isSessionExpired()) {
    logout();
    return null;
  }


  // Vendor route restriction
  const loginType = sessionStorage.getItem("LoginType");

  if (loginType === "vendor") {
    const allowedRoutes = [
      "/Registration",
      //"/Card_Scan",       // allow this if vendor has Card Scan permission
    ];

    if (!allowedRoutes.includes(location.pathname)) {
      return <Navigate to="/Registration" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;